<template>
    <label class="base-input text-input" :class="type">
        <span v-if="showLabel" v-text="label"></span>
        <input type="password" v-model="value" :class="inputClass" @input="actionInput"/>
        <span v-if="!correctPassword" class="base-input-desc">Password must contain at least 8 characters, a single uppercase letter, a single lowercase letter, and one number.</span>
        <span v-else-if="!samePasswords" class="base-input-desc">Passwords are not the same.</span>
    </label>
</template>

<script>
    import BaseInput from "./BaseInput.js";

    export default {
        name: "PasswordInput",
        mixins: [BaseInput],
        props: {
            checkPassword: {
                type: Boolean,
                default: false,
            },
            samePasswords: {
                type: Boolean,
                default: true,
            }
        },
        computed: {
            inputClass() {
                return {
                    'success': this.checkPassword && (this.correctPassword && this.samePasswords) && this.value.length > 0,
                    'error': this.checkPassword && (!this.correctPassword || !this.samePasswords) && this.value.length > 0,
                }
            },
            correctPassword() {
                return !this.checkPassword || this.value.length >= 8 && this.value.search(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/) == 0 || this.value.length <= 0;
            },
        },
        methods: {
            actionInput() {
                this.$emit('input');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/base-input";
</style>